import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";


interface LocationData {
    id: number;
    location_name: string;
    schedule_url: string;
    created_at: string;
    sensorid: string;
    timezone: string;
    street_address1: string;
    streetaddress2: string | null;
    city: string;
    state: string;
    zipcode: string;
    latitude: string;
    longitude: string;
}

interface LocationCardProps {
    location: LocationData;
}

const LocationCard: React.FC<LocationCardProps> = ({ location }) => {
    return (
        <MDBox p={2}>
            <MDTypography variant="h5">{location.location_name}</MDTypography>
            <MDTypography variant="subtitle2" color="text">
                {location.street_address1}
                {location.streetaddress2 ? `, ${location.streetaddress2}` : ""}
                <br />
                {location.city}, {location.state} {location.zipcode}
            </MDTypography>
        </MDBox>
    );
};

export default LocationCard;
